import { Form } from 'antd';
import { useFormikContext } from 'formik';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterMenuType } from '..';
import { type MenuItemSpecsFragment } from '../../../../../api/fragments/MenuItemSpecs';
import { type RouterSpecsFragment } from '../../../../../api/fragments/RouterSpecs';
import { Select } from '../../../../../components/fields/SelectField';
import RouterMenuItemCustom from './RouterMenuItemCustom';
import RouterMenuItemEndpoint from './RouterMenuItemEndpoint';
import RouterMenuItemLogout from './RouterMenuItemLogOut';

type MenuItemGroupProps = {
    router: RouterSpecsFragment;
    menuItems: MenuItemSpecsFragment[];
};

const routerMenuItemOption = () => {
    const { t } = useTranslation('routerDetails');

    return [
        { label: t('routerDetails:menuItems.menuItemType.endpoint'), value: RouterMenuType.Endpoint },
        { label: t('routerDetails:menuItems.menuItemType.custom'), value: RouterMenuType.Custom },
        { label: t('routerDetails:menuItems.menuItemType.logout'), value: RouterMenuType.LogOut },
    ];
};

const MenuItemGroup = ({ router, menuItems }: MenuItemGroupProps) => {
    const { t } = useTranslation('routerDetails');
    const { setValues } = useFormikContext();

    const [menuType, setMenuType] = useState<RouterMenuType>(RouterMenuType.Endpoint);

    const onChange = useCallback(values => {
        setMenuType(values);
    }, []);

    useEffect(() => {
        switch (menuType) {
            case RouterMenuType.Custom:
                setValues({
                    customPathItem: {
                        label: {
                            defaultValue: '',
                            overrides: [],
                        },
                    },
                });
                break;

            case RouterMenuType.Endpoint:
                setValues({
                    endpointItem: {
                        label: {
                            defaultValue: '',
                            overrides: [],
                        },
                    },
                });
                break;

            case RouterMenuType.LogOut:
                setValues({
                    logoutActionItem: {
                        label: {
                            defaultValue: '',
                            overrides: [],
                        },
                    },
                });
                break;

            default:
                break;
        }
    }, [menuType, setValues]);

    return (
        <>
            <Form.Item label={t('routerDetails:menuItems.fields.menuItemType.label')}>
                <Select onSelect={onChange} options={routerMenuItemOption()} value={menuType} />
            </Form.Item>

            {menuType === RouterMenuType.Endpoint && (
                <RouterMenuItemEndpoint endpoints={router.endpoints} menuItems={menuItems} name="endpointItem" />
            )}
            {menuType === RouterMenuType.Custom && <RouterMenuItemCustom name="customPathItem" />}
            {menuType === RouterMenuType.LogOut && <RouterMenuItemLogout name="logoutActionItem" />}
        </>
    );
};

export default MenuItemGroup;
